module.exports = __webpack_public_path__ + "img/natural_beech_662l_detail_rsh.c5dd75a6.jpg";